import { useState, useCallback, useEffect } from 'react';
import {
  useParticipantIds,
  useScreenShare,
  useDailyEvent,
  useActiveSpeakerId,
} from '@daily-co/daily-react';

import './Call.css';
import { useRecoilState } from 'recoil';
import UserMediaError from '../UserMediaError/UserMediaError';
import { regularParticipantsIdState, teacherIdState } from '../../state/participantAtom';
import ParticipantProcessor from '../ParticipantProcessor';
import Participants from './Participants/Participants';
import Teacher from './Teacher/Teacher';

export default function Call() {
  const [getUserMediaError, setGetUserMediaError] = useState(false);
  const [regularParticipantsIds, setRegularParticipantsIds] = useRecoilState(
    regularParticipantsIdState,
  );
  const [teacherId, setTeacherId] = useRecoilState(teacherIdState);

  const activeSpeakerId = useActiveSpeakerId();

  useDailyEvent(
    'camera-error',
    useCallback(() => {
      setGetUserMediaError(true);
    }, []),
  );

  // const { screens } = useScreenShare();
  const remoteParticipantIds = useParticipantIds();

  // Process participants and categorize them
  const handleTeacherFound = useCallback(
    (id) => {
      setTeacherId(id);
    },
    [setTeacherId],
  );

  const handleRegularParticipant = useCallback(
    (id) => {
      setRegularParticipantsIds((prev) => {
        if (!prev.includes(id)) {
          return [...prev, id];
        }
        return prev;
      });
    },
    [setRegularParticipantsIds],
  );

  // Clear regular participants when remote IDs change
  useEffect(() => {
    setRegularParticipantsIds((prev) => prev.filter((id) => remoteParticipantIds.includes(id)));
  }, [remoteParticipantIds, setRegularParticipantsIds]);

  const { screens } = useScreenShare();

  const [teacherScreen, setTeacherScreen] = useState(null);

  useEffect(() => {
    const teacherScreenInSession = screens.find((screen) => screen.session_id === teacherId);
    if (teacherScreenInSession) {
      setTeacherScreen(teacherScreenInSession);
    } else {
      setTeacherScreen(null);
    }
  }, [screens]);

  useEffect(() => {
    setRegularParticipantsIds((prev) => {
      if (!activeSpeakerId || !prev.includes(activeSpeakerId)) {
        return prev;
      }
      return [activeSpeakerId, ...prev.filter((id) => id !== activeSpeakerId)];
    });
  }, [activeSpeakerId, setRegularParticipantsIds]);

  const renderCallScreen = () => (
    <div className="call">
      {remoteParticipantIds.map((id) => (
        <ParticipantProcessor
          key={`processor-${id}`}
          id={id}
          onTeacherFound={handleTeacherFound}
          onRegularParticipant={handleRegularParticipant}
        />
      ))}
      <Teacher teacherScreen={teacherScreen} />
      <Participants regularParticipantsIds={regularParticipantsIds} />
    </div>
  );

  return getUserMediaError ? <UserMediaError /> : renderCallScreen();
}
